import React, { useId, useMemo } from "react";

const fallbackTimeZones = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "Pacific/Honolulu",
  "UTC",
];

export function allTimeZones() {
  if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
    try {
      return Intl.supportedValuesOf("timeZone");
    } catch {
      return fallbackTimeZones;
    }
  }
  return fallbackTimeZones;
}

export default function TimeZoneCombo({ label = "Time zone", value, onChange, placeholder = "Search time zones" }) {
  const inputId = useId();
  const listId = useId();
  const options = useMemo(() => {
    const zones = allTimeZones();
    return Array.from(new Set([value, ...zones].filter(Boolean))).sort((a, b) => a.localeCompare(b));
  }, [value]);

  return (
    <div className="timezone-combo">
      {label ? <label htmlFor={inputId}>{label}</label> : null}
      <input
        id={inputId}
        list={listId}
        value={value || ""}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        autoComplete="off"
      />
      <datalist id={listId}>
        {options.map((zone) => <option key={zone} value={zone} />)}
      </datalist>
    </div>
  );
}
